import Immutable from "immutable";

export default {
    CLEAR_WIDGETS_CONFIG: (state, action) => {
        let cachedWidgets = action.payload.cachedWidgets || {};
        return state.filter((widgetData, widgetKey) => {
            return cachedWidgets[widgetKey];
        });
    },
    CLEAR_WIDGET_CONFIG: (state, action) => {
        let widgetId = action.payload.widgetId;
        return state.filter((widgetData, widgetKey) => {
            return widgetKey !== widgetId;
        });
    },
    MIXIN_SUCCESS: (state, action) => {
        return state.setIn(action.path, Immutable.fromJS(action.payload));
    },
    WIDGET_SUCCESS: (state, action) => {
        return state.setIn([action.payload.widget], Immutable.fromJS(action.payload));
    },
    RELOAD_WIDGET_SUCCESS: (state, action) => {
        return state.setIn([action.payload.widget], Immutable.fromJS(action.payload));
    },
    STEP_SUCCESS: (state, action) => {
        let res = {};
        let flowConfig = state.getIn([action.payload.widgetId, "components", 0]);
        if (!flowConfig.get("components")) {
            flowConfig = flowConfig.set("components", new Immutable.List([]));
        }
        let stepIdx = flowConfig.get("components").findIndex(item => {
            return item.get("id") === action.payload.id;
        });

        if (stepIdx > -1) {
            let stepConfig = flowConfig.getIn(["components", stepIdx]);
            res = state.setIn(
                [action.payload.widgetId, "components", 0, "components", stepIdx],
                stepConfig.merge(action.payload)
            );
        } else {
            let components = flowConfig.get("components").push(Immutable.fromJS(action.payload));

            res = state.setIn([action.payload.widgetId, "components", 0, "components"], components);
        }
        return res;
    },
    //set "visible" flag for a step in a flow that displays only a single step at a time
    SET_VISIBLE_STEP: (state, action) => {
        let widgetId = action.payload.widgetId;
        let stedId = action.payload.stepId;

        //warning flow config extracted by exact position
        let steps = state.getIn([widgetId, "components", 0, "components"]);

        // let stepIndex = steps.findIndex((item)=> {
        //     return item.get("step") === stedId;
        // });

        steps.forEach((step, index) => {
            let name = step.getIn(["id"]);
            let visible = step.getIn(["visible"]);
            let newVisibility = false;

            if (name === stedId) {
                newVisibility = true;
            }

            if (visible !== newVisibility) {
                state = state.setIn(
                    [action.payload.widgetId, "components", 0, "components", index, "visible"],
                    newVisibility
                );
            }
        });

        return state;
    },
    SET_CONFIG: (state, action) => {
        let path = Array.isArray(action.payload.path)
            ? action.payload.path
            : action.payload.path.split(".");
        let toSet = action.payload && action.payload.path ? state.getIn(path) : {};
        if (toSet && action.payload.toSet) {
            if (action.payload.overwrite) {
                return state.setIn(path, Immutable.fromJS(action.payload.toSet));
            } else {
                return state.setIn(path, toSet.mergeDeep(action.payload.toSet));
            }
        } else {
            return state;
        }
    }
};
